import ShiftLeaderAnswerPage from 'pages/answer/shift/leader/page'
import ShiftMemberAnswerPage from 'pages/answer/shift/member/page'

export const answerRoutes = [
  { path: '/answer/shift', element: <ShiftMemberAnswerPage /> },
  { path: '/answer/shift_leader', element: <ShiftLeaderAnswerPage /> },
]
